import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
export default {
  props: {
    propRes: {
      type: Object,
      default: function _default() {
        return {
          A: "contractA",
          B: "contractB",
          city: {
            ch: "北京",
            en: "Beijing"
          },
          district: {
            ch: "朝阳",
            en: "Chaoyang"
          },
          address: "领地office",
          occupyTime: "2017-12-16",
          quitTime: "2018-02-01",
          rent: 123,
          deposit: 123,
          create: "2017-12-07"
        };
      }
    }
  },
  data: function data() {
    return {
      res: this.propRes
    };
  },
  mounted: function mounted() {
    if (this.propRes.A === "contractA") {
      this.getContractInfo();
    }
  },
  computed: {
    addressZh: function addressZh() {
      return this.res.city.ch + this.res.district.ch + this.res.address;
    },
    addressEn: function addressEn() {
      return this.res.city.en + this.res.district.en + this.res.address;
    }
  },
  methods: {
    getContractInfo: function getContractInfo() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _this.$api.getContractInfo({
                id: _this.$route.query.id
              });
            case 1:
              res = _context.v;
              _this.res = res.data;
              _this.$nextTick(function () {
                setTimeout(function () {
                  window.print();
                }, 1000);
              });
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    }
  },
  watch: {
    propRes: function propRes(val) {
      this.res = val;
    }
  }
};